import React, { Component } from 'react';
import { connect } from 'react-redux';

import Customers from '../../views/Customers';
import { loadCustomers, updateCustomer } from '../../store/customers/action';
import { onChangeStatus, onSelectCustomer } from '../../store/customer/action';
import { modalToggle } from '../../store/modal/action';
import { parseLocationSearch } from '../../helpers';

export class CustomersContainer extends Component {
 
  componentWillReceiveProps(nextProps) {
    if  (this.props.location.search !== nextProps.location.search) {
      this.props.loadCustomers(parseLocationSearch(nextProps.location.search));
    }
  }
  componentDidMount() {
    this.props.loadCustomers(parseLocationSearch(this.props.location.search));
  }
  render() {
    return (<Customers 
              { ... this.props }
              customers={ this.props.customers }
              meta={ this.props.meta }
              isOpen={ this.props.modal }
              loadCustomers={ this.props.loadCustomers }
              selectedCustomer={ this.props.selectedCustomer }
              customerLoading={ this.props.customerLoading }
              customerError={ this.props.customerError }
              updateCustomer={ this.props.updateCustomer }
              onChangeStatus={ this.props.onChangeStatus }
              onSelectCustomer={ this.props.onSelectCustomer }
              toggleModal={ this.props.toggleModal }
            />)
  }
}

const mapStateToProps = ({ customers, customer, modal }) => {
  return {
    customers: customers.data,
    meta: customers.meta,
    selectedCustomer: customer.data,
    customerLoading: customer.loading,
    customerError: customer.error,
    modal: modal.isOpen
  }
};

const mapDispatchToProps = dispatch => ({
  loadCustomers: params => dispatch(loadCustomers(params)),
  updateCustomer: customer => dispatch(updateCustomer(customer)),
  onChangeStatus: customer => dispatch(onChangeStatus(customer)),
  onSelectCustomer: customer => dispatch(onSelectCustomer(customer)),
  toggleModal: status => dispatch(modalToggle(status))
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomersContainer);



// WEBPACK FOOTER //
// ./src/containers/Customers/Customers.js